import React from "react";

export const AlertTriangle: React.FC = () => {
  return (
    <svg
      width="28px"
      height="25px"
      style={{ minWidth: "28px", minHeight: "25px" }}
      viewBox="0 0 28 25"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Combined Shape</title>
      <defs>
        <filter colorInterpolationFilters="auto" id="filter-1">
          <feColorMatrix
            in="SourceGraphic"
            type="matrix"
            values="0 0 0 0 1.000000 0 0 0 0 0.231373 0 0 0 0 0.188235 0 0 0 1.000000 0"
          />
        </filter>
      </defs>
      <g
        id="About-Detail-Pages"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Contac-Us-Error" transform="translate(-131.000000, -574.000000)">
          <g
            id="Group"
            transform="translate(130.000000, 572.000000)"
            filter="url(#filter-1)"
          >
            <g>
              <path
                d="M15,2.75000067 C16.0260052,2.75000067 16.9742524,3.29677409 17.4882359,4.18475516 L17.4882359,4.18475516 L27.7979544,21.9963453 C28.3127954,22.8857985 28.3137055,23.9824233 27.8003415,24.8727298 C27.2869787,25.7630341 26.3374259,26.3116035 25.3097168,26.3116035 L25.3097168,26.3116035 L4.69028672,26.3116035 C3.6625797,26.3116035 2.71302908,25.7630312 2.19966637,24.8727276 C1.68630364,23.982424 1.68721059,22.8858032 2.20204491,21.9963506 L2.20204491,21.9963506 L12.5117648,4.18475402 C13.0257476,3.29677409 13.9739948,2.75000067 15,2.75000067 Z M15,4.75000067 C14.6877375,4.75000067 14.3991406,4.91640997 14.2427117,5.1866635 L14.2427117,5.1866635 L3.93299226,22.9982594 C3.77630273,23.2689638 3.7760267,23.6027195 3.93226826,23.8736827 C4.08850981,24.1446459 4.37750483,24.3116035 4.69028672,24.3116035 L4.69028672,24.3116035 L25.3097168,24.3116035 C25.6225032,24.3116035 25.9114989,24.1446468 26.0677393,23.8736854 C26.2239805,23.6027226 26.2237035,23.2689672 26.0670098,22.9982589 L26.0670098,22.9982589 L15.757289,5.18666473 C15.6008594,4.91640997 15.3122625,4.75000067 15,4.75000067 Z M15,19.6875 C15.7766504,19.6875 16.40625,20.3170996 16.40625,21.09375 C16.40625,21.8704004 15.7766504,22.5 15,22.5 C14.2233496,22.5 13.59375,21.8704004 13.59375,21.09375 C13.59375,20.3170996 14.2233496,19.6875 15,19.6875 Z M15,10.25 C15.5128358,10.25 15.9355072,10.6360402 15.9932723,11.1333789 L16,11.25 L16,16.875 C16,17.4272847 15.5522847,17.875 15,17.875 C14.4871642,17.875 14.0644928,17.4889598 14.0067277,16.9916211 L14,16.875 L14,11.25 C14,10.6977153 14.4477153,10.25 15,10.25 Z"
                id="Combined-Shape"
                fill="#000000"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default {};
